import { Controller } from "stimulus"

// Rooster 1 (#1515): de eindtijd volgt de standaardduur van het gekozen
// afspraaktype, zolang de gebruiker de eindtijd niet zelf heeft aangepast.
// Bij een andere begintijd schuift de eindtijd mee met dezelfde duur.
// Rooster 2 (#1516): het maximum aantal deelnemers toont als voorbeeldwaarde
// het maximum van het gekozen type.
// Rooster 4 (#1518): de keuze hoe een reeks eindigt staat alleen open als de
// afspraak herhaald wordt. Zonder JavaScript staat hij gewoon open.
// #1515 vervolg: een afspraak mag over middernacht lopen. Een eindtijd vóór de
// begintijd valt op de volgende dag (zoals Appointment#zet_tijden rekent);
// dan staat "+1 dag" bij de eindtijd.
export default class extends Controller {
  static targets = ["type", "begin", "eind", "maximum", "maximumHulp", "herhaling", "einde", "volgendeDag"]

  connect() {
    this.handmatig = false
    this.duur = this.huidigeDuur() || this.typeDuur()
    this.herhalingGekozen()
    this.toonVolgendeDag()
  }

  typeGekozen() {
    this.toonTypeMaximum()
    if (this.handmatig) return
    this.duur = this.typeDuur()
    this.zetEind()
  }

  herhalingGekozen() {
    if (!this.hasHerhalingTarget || !this.hasEindeTarget) return
    this.eindeTarget.hidden = this.herhalingTarget.value === "0"
  }

  beginGewijzigd() {
    this.zetEind()
  }

  eindGewijzigd() {
    this.handmatig = true
    this.duur = this.huidigeDuur() || this.duur
    this.toonVolgendeDag()
  }

  toonTypeMaximum() {
    if (!this.hasMaximumTarget) return
    const optie = this.typeTarget.selectedOptions[0]
    const maximum = optie ? optie.dataset.maximum : ""
    this.maximumTarget.placeholder = maximum || ""
    if (this.hasMaximumHulpTarget) {
      const hulp = this.maximumHulpTarget
      hulp.textContent = maximum ? hulp.dataset.hulpType.replace("%{maximum}", maximum) : hulp.dataset.hulpGeen
    }
  }

  toonVolgendeDag() {
    if (!this.hasVolgendeDagTarget) return
    const begin = this.minuten(this.beginTarget.value)
    const eind = this.minuten(this.eindTarget.value)
    this.volgendeDagTarget.hidden = !(begin !== null && eind !== null && eind < begin)
  }

  typeDuur() {
    const optie = this.typeTarget.selectedOptions[0]
    return optie ? parseInt(optie.dataset.duur, 10) || 60 : 60
  }

  // De duur in minuten; een eindtijd vóór de begintijd is de volgende dag
  huidigeDuur() {
    const begin = this.minuten(this.beginTarget.value)
    const eind = this.minuten(this.eindTarget.value)
    if (begin === null || eind === null || eind === begin) return null
    return eind > begin ? eind - begin : eind + 24 * 60 - begin
  }

  zetEind() {
    const begin = this.minuten(this.beginTarget.value)
    if (begin !== null && this.duur) {
      const eind = (begin + this.duur) % (24 * 60)
      this.eindTarget.value = `${String(Math.floor(eind / 60)).padStart(2, "0")}:${String(eind % 60).padStart(2, "0")}`
    }
    this.toonVolgendeDag()
  }

  minuten(waarde) {
    const delen = /^(\d{1,2}):(\d{2})/.exec(waarde || "")
    return delen ? parseInt(delen[1], 10) * 60 + parseInt(delen[2], 10) : null
  }
}
